import React from "react";
import { Flex } from "..";
import { HashLink as Link } from 'react-router-hash-link';
import style from "./style.module.scss";
import { trackNavClick } from "../../Utils/Analytics";

export interface SubItem {
  label: string;
  to?: string;
}

export interface NavGroupItem {
  main: SubItem;
  items?: SubItem[];
}

export interface FooterNavGroupProps {
  item: NavGroupItem;
}

export const NavGroup = React.memo(({ item }: FooterNavGroupProps) => {
  const { main, items } = item;
  return (
    <Flex
      className={style.navGroup}
      column
      justify="flex-start"
      align="flex-start"
    >
      <Link smooth to={main.to} className={style.mainButton} onClick={() => trackNavClick(main.label, "footer")}>
        <h4 style={{ fontSize: 18, whiteSpace: "nowrap" }}>{main.label}</h4>
        <div className={style.mainDivider} />
      </Link>
      {!!items?.length && (
        <ul>
          {items.map((i, key) => (
            <li key={key}>
              <Link smooth to={i.to} onClick={() => trackNavClick(i.label, "footer")}><button>{i.label}</button></Link>
            </li>
          ))}
        </ul>
      )}
    </Flex>
  );
});
